import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="grain-overlay" />
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-lg text-center border border-white/10 bg-black/40 backdrop-blur-xl p-12">
        <Link to="/" className="flex items-center justify-center mb-10">
          <img src="/logo-jayatk.png" alt="Jay Atk" className="h-10 w-auto" />
        </Link>
        <XCircle className="w-12 h-12 text-[#A19D94] mx-auto mb-6" />
        <h1 className="font-serif-display text-4xl text-[#FDFBF7]">Checkout cancelled</h1>
        <p className="text-[#A19D94] mt-3">No worries — your card wasn't charged. You can grab your ticket whenever you're ready.</p>
        <Link to="/#events" data-testid="cancel-retry"
          className="inline-block mt-8 text-xs uppercase tracking-[0.2em] border border-[#D4AF37] text-[#D4AF37] px-8 py-3 hover:bg-[#D4AF37] hover:text-black transition-colors duration-300">
          Back to Tickets
        </Link>
      </motion.div>
    </div>
  );
}
